import { render, staticRenderFns } from "./BvaNavMenu.vue?vue&type=template&id=75a2b13f&scoped=true&"
import script from "./BvaNavMenu.vue?vue&type=script&lang=js&"
export * from "./BvaNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./BvaNavMenu.vue?vue&type=style&index=0&id=75a2b13f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a2b13f",
  null
  
)

export default component.exports